import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip
} from "@mui/material";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import ImageModal from "./ImageModal";

const ViewLegal = (props) => {
    const { open, handleClose, rowData, isLoading } = props;
    const [isShow, setIsShow] = useState(false);
    const [viewImage, setViewImage] = useState(null)
    const [title, setTitle] = useState("")

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
        whiteSpace: "pre-line",
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };


    const handleClick = (url, title) => {
        setViewImage(url)
        setTitle(title)
        setIsShow(true)
    }

    const handleCloseImage = () => {
        setViewImage(null);
        setTitle("")
        setIsShow(false)
    }
    return (
        <>

            <Dialog
                open={open}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        backgroundColor: "#FFFFFF",
                        width: "100%",
                        overflowX: "hidden"
                    },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                    position: "relative",
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: "27px",
                            lineHeight: "100%",
                            color: "#140F36",
                            fontFamily: "Outfit, sans-serif"
                        }}>
                            View legal Compliance Details
                        </Typography>
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 50,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{
                                        fontWeight: 600,
                                        fontSize: "20px",
                                        fontFamily: "Outfit, sans-serif",
                                        color: "#0A0A0C"
                                    }}>
                                        Compliance Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 3 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ xs: 12 }}>
                                            <Grid container spacing={2}>

                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Type:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.type ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Section/Rule/Clause:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.sectionRuleClause ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Applicable requirement of the section/Rules/Clause:</strong>
                                                    </Typography>
                                                    <Typography sx={{
                                                        fontSize: "15px",
                                                        color: "#111827",
                                                        fontWeight: 500,
                                                        mb: 2,
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: "8px",
                                                        backgroundColor: "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "40px",
                                                        lineHeight: "1.5",
                                                        whiteSpace: "pre-line",
                                                    }}>
                                                        {rowData?.applicableRequirement ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Requirement of Compliance:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.requirementOfCompliance ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Compliance Frequency:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.complianceFrequency ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Responsibility:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.responsibility ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Status of Compliance:</strong>
                                                    </Typography>
                                                    <Chip
                                                        label={rowData?.statusOfCompliance ?? "N/A"}
                                                        sx={valueStyle}
                                                    />
                                                </Grid>





                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Remarks:</strong>
                                                    </Typography>
                                                    <Typography sx={{
                                                        fontSize: "15px",
                                                        color: "#111827",
                                                        fontWeight: 500,
                                                        mb: 2,
                                                        fontFamily: "Outfit, sans-serif",
                                                        padding: "8px",
                                                        backgroundColor: "#f8f9fa",
                                                        borderRadius: "6px",
                                                        minHeight: "40px",
                                                        lineHeight: "1.5"
                                                    }}>
                                                        {rowData?.remarks ?? "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 12 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Compliance Evidence:</strong>
                                                    </Typography>
                                                    {/* <Typography sx={valueStyle}>
                                                    {rowData?.complianceEvidence ?? "N/A"}
                                                </Typography> */}
                                                    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                        {rowData?.complianceEvidence && rowData.complianceEvidence.length > 0 ? (
                                                            rowData.complianceEvidence.map((file, index) => (
                                                                <img
                                                                    key={index}
                                                                    src={file?.filePath}
                                                                    alt="complianceEvidence"
                                                                    width={240}
                                                                    height={240}
                                                                    style={{
                                                                        objectFit: "cover",
                                                                        borderRadius: 6,
                                                                        border: "1px solid #ddd",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => handleClick(file?.filePath, "View Compliance Evidence")}
                                                                />
                                                            ))
                                                        ) : (
                                                            <Typography variant="body2" sx={{ ...valueStyle, whiteSpace: "pre-line" }}>N/A</Typography>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            <ImageModal
                open={isShow}
                handleClose={handleCloseImage}
                fileUrl={viewImage}
                title={title}
            /></>
    );
};

export default ViewLegal;